import { gql } from "apollo-boost";

export const DELETE_FAVORITE = gql`
  mutation DeleteFavorite($input: DeleteFavoriteInput!) {
    deleteFavorite(input: $input)
  }
`;
